import angular from 'angular';
import {
  loaderService,
  eduDataService
} from 'app/services';
import { searchInput } from 'app/components/global';
import trainingMediaList from './trainingMediaList';
import controller from './training.controller';
import directive from './training.directive';


export const routeConfig = {
  controller: 'TrainingController',
  controllerAs: 'trainingVM',
  template: require('./training.html'),
};

export default angular.module('app.components.support.training', [
  loaderService,
  eduDataService,
  searchInput,
  trainingMediaList,
])
  .directive('training', directive)
  .controller('TrainingController', controller)
  .name;

console.log('app.components.support.training created');
